import axios from "infra/http";
import { useQuery } from "react-query";
import { PessoaDto } from "./typings/unidade";

function useUnidadePessoa(id: string, pessoaId?: string | null) {
  return useQuery(
    `/v1/unidades/${id}/pessoas/${pessoaId}`,
    async () => {
      const res = await axios.get<PessoaDto>(
        `/v1/unidades/${id}/pessoas/${pessoaId}`
      );

      return res.data;
    },
    {
      enabled: !!pessoaId,
    }
  );
}

export default useUnidadePessoa;
